<!--
 * @Descripttion: 批量审核资质
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <base-dialog
    :visible="true"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    title="批量审核资质"
    width="470px"
  >
    <div style="padding: 20px" class="batch-qualifications-audit">
      <BaseAlert
        :title="`您正在对${selectionRows.length}个终端服务者项目资质进行审核，请选择审核结果。`"
        type="warning"
        :closable="false"
      ></BaseAlert>
      <BaseForm ref="formRef" :model="formData" label-position="right">
        <BaseFormItem
          :rules="[{ required: true, message: '请选择审核状态' }]"
          prop="auditStatus"
          label=""
        >
          <BaseRadioGroup
            style="width: 100%; height: 32px; margin: 20px 0"
            v-model="formData.auditStatus"
          >
            <BaseRadio border :value="2">审核通过</BaseRadio>
            <BaseRadio border :value="3">审核不通过</BaseRadio>
          </BaseRadioGroup>
        </BaseFormItem>
        <BaseFormItem
          v-if="formData.auditStatus === 3"
          :rules="auditOptionRules"
          prop="auditOpinion"
          label=""
        >
          <BaseInput
            placeholder="请填写审核不通过原因，最少5个字"
            v-model="formData.auditOpinion"
            style="width: 100%"
            :maxlength="150"
            :show-word-limit="true"
            type="textarea"
            :rows="5"
          ></BaseInput>
        </BaseFormItem>
      </BaseForm>
    </div>
    <template #footer>
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onConfirm" type="primary">确认</BaseButton>
    </template>
  </base-dialog>
</template>

<script lang="tsx" setup>
import { reactive, ref, withDefaults, defineProps, defineEmits } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseAlert,
  BaseFormRef,
  BaseRadioGroup,
  BaseRadio,
  BaseDialog,
  BaseButton
} from 'xrk-components';
import { auditQua } from '../data-source/apis';

// 声明 prop 属性
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    projectId: number;
    selectionRows: [{ userId: number }];
  }>(),
  {
    remove() {
      return () => ({});
    },
    projectId: null,
    selectionRows: null
  }
);

const emits = defineEmits(['confirm']);

const formData = reactive({
  auditOpinion: '',
  auditStatus: null
});
const formRef = ref<BaseFormRef>(null);
const onCancel = () => {
  props.remove();
};

const auditOptionRules = [
  {
    required: true,
    validator: (rule: any, value: any, callback: any) => {
      if (value === '') {
        return callback(new Error('请填写不通过原因，最少5个字'));
      } else if (value.length < 5) {
        return callback(new Error('请填写不通过原因，最少5个字'));
      } else {
        callback();
      }
    }
  }
];

const onConfirm = async () => {
  await formRef.value.validate();
  await auditQua({
    projectId: props.projectId,
    userId: props.selectionRows.map(item => item.userId),
    auditStatus: formData.auditStatus,
    auditOpinion: formData.auditOpinion,
    auditType: 1
  });
  props.remove();
  emits('confirm');
};
</script>
<style lang="scss"></style>
